import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import '@/styles/index.css'
import 'reset-css'
import { isMobile } from '@/utils/utils';
// console.log(process.env.NODE_ENV ,'--NODE_ENV');

let url = location.href.split("=");
document.title = url[1]
//  引入amfe-flexible
 import 'amfe-flexible'
Vue.config.productionTip = false
Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
